import { FC, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useCampaignsActions } from '../context';
import { CreateCampaignFormInput, CreateCampaignFormOutput } from '../validation';
import { CampaignSummaryItem, CampaignSummaryItemField } from './CampaignSummaryItem';
import { CampaignStepSummaryProps } from './CampaignSummarySection';

export const NewCampaignStepSummary: FC<CampaignStepSummaryProps> = ({ isStepCompleted }) => {
  const { t } = useTranslation();

  const { setStep } = useCampaignsActions();
  const { control } = useFormContext<CreateCampaignFormInput, unknown, CreateCampaignFormOutput>();

  const title = useWatch({
    control,
    name: 'name',
  });

  const description = useWatch({
    control,
    name: 'description',
  });

  const content = useMemo<CampaignSummaryItemField[]>(
    () => [...(title ? [{ field: t('COMMON:title'), value: title }] : []), ...(description ? [{ field: t('COMMON:description'), value: description }] : [])],
    [title, description]
  );

  return (
    <CampaignSummaryItem
      index={1}
      title={t('ALL:campaignSummary')}
      content={content}
      {...(isStepCompleted && { onClick: () => setStep('CreateNewCampaign') })}
    />
  );
};
